/*
*
* @module : Challenge
* @file : Challenge.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Home
*
* Created on : 15-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 21-Oct-2019
*/

import React from 'react';
import {Link} from 'react-router-dom';
import ChallengeService from '../../services/ChallengeService/ChallengeService';
import Translation from '../../language/Translation';
class Home extends React.Component
{
	constructor(props)
	{
		super(props);
		this.translation = new Translation();
		this.state = {
			challenger_name:'',
			topic_id:'',
			is_completed:'',
			translation:{
				'challenge_v1':this.translation.getText('challenge_v1'),
				'challenge_v2':this.translation.getText('challenge_v2'),
				'challenge_v3':this.translation.getText('challenge_v3'),
				'challenge_v4':this.translation.getText('challenge_v4'),
				'challenge_v5':this.translation.getText('challenge_v5'),
				'challenge_v6':this.translation.getText('challenge_v6'),
				'challenge_v7':this.translation.getText('challenge_v7'),
				'challenge_v8':this.translation.getText('challenge_v8'),
				'challenge_v9':this.translation.getText('challenge_v9'),
			}
		};
		this.challengeService = new ChallengeService();
	}

	componentDidMount()
	{
		const challenge_id = this.props.match.params.challenge_id;
		sessionStorage.setItem('session_id', challenge_id);
		this.challengeService.getChallengerData(challenge_id).then(response=>{
			if(response.status==='1')
			{
				this.setState({challenger_name:response.challenger_name});
				this.setState({topic_id:response.topic_id});
				this.setState({is_completed:response.is_completed});
				this.renderChallenger();
			}
		});
	}
	renderChallenger()
	{
		
			let challenger_name = this.state.challenger_name;
			if(this.state.challenger_name!=='' || typeof this.state.challenger_name!=='undefined')
			{
				this.state.translation.challenge_v2 = this.state.translation.challenge_v2.replace('%challenger_name%',''+challenger_name+'');
				return (
					<React.Fragment>
						<p>{this.state.translation.challenge_v2}</p>
					</React.Fragment>
				)
			}
			else
			{
				return(
					<React.Fragment>
					</React.Fragment>
				)
			}
		
		
	}
	render()
	{
		if(this.state.is_completed==='1' || this.state.is_completed===1)
		{
			return (
			<React.Fragment>
			<div className="content-box-area">
				<div className="default-heading">
				<h2>{this.state.translation.challenge_v7}</h2>
				</div>
				<div className="paragraph-area paragraph-area-small">
				<p><strong>{this.state.translation.challenge_v8}</strong></p>
				</div>
				<div className="text-center buttons-area">
				<Link to={'/'} className="btn btn-primary">{this.state.translation.challenge_v9}</Link>
				</div>
			</div>
			</React.Fragment>
			);
		}
		else if(this.state.is_completed==='0' || this.state.is_completed===0)
		{
		return (
			<React.Fragment>
				<div className="content-box-area">
				<div className="default-heading">
				<h2>{this.state.translation.challenge_v1}</h2>
				</div>
				<div className="default-heading">
				<p>{this.state.challenger_name} {this.state.translation.challenge_v2}</p>
				<p>{this.state.translation.challenge_v3}</p>
				</div>
				<div className="paragraph-area">
				<p>{this.state.translation.challenge_v4}</p>
				<p>{this.state.translation.challenge_v5}</p>
				</div>
				<div className="text-center buttons-area">
				<Link to={'/topics/'+this.state.topic_id+'/question'} className="btn btn-primary">{this.state.translation.challenge_v6}</Link>
				</div>
				</div>
			</React.Fragment>
		);
		}
		else {
			{
				return (
			<React.Fragment>
				<div className="content-box-area">				
				</div>
			</React.Fragment>
		);
			}
		}
	}
}

export default Home;